export default __webpack_public_path__ + "static/media/LS-400.e7c58387.pdf";